export const actionType = {
  GET_CLIENTS_START: 'CLIENTS/GET_CLIENTS_START',
  GET_CLIENTS: 'CLIENTS/GET_CLIENTS',
  GET_CLIENTS_FAIL: 'CLIENTS/GET_CLIENTS_FAIL',
  ADD_CLIENT_START: 'CLIENTS/ADD_CLIENT_START',
  ADD_CLIENT: 'CLIENTS/ADD_CLIENT',
  ADD_CLIENT_FAIL: 'CLIENTS/ADD_CLIENT_FAIL',
  CLIENTS_CLEAR_ERROR: 'CLIENTS/CLEAR_ERROR',
};
